import { buildMockPromise } from "../api/helpers";
import {
  CreateItemPostRatingRequest,
  CreateItemPostRatingResponse,
  CreateManualScrapePostResponse,
  CreatePostApi,
  RemovePostItemRequest,
  UpdateItemPostRatingRequest,
  UpdateItemPostRatingResponse,
} from "../api/Items";
import { v4 as uuidv4 } from "uuid";

export async function removePostsItemMock(
  input: RemovePostItemRequest
): Promise<string> {
  return await buildMockPromise("OK", 1000);
}

export async function createPostsItemRatingMock(
  input: CreateItemPostRatingRequest
): Promise<CreateItemPostRatingResponse> {
  return await buildMockPromise(
    {
      ratings: [],
      item_uuid: "",
    },
    1000
  );
}

export async function createPostsMock(input: CreatePostApi): Promise<string> {
  return await buildMockPromise("OK", 1000);
}

export async function createManualScrapePostMock(
  input: CreatePostApi
): Promise<CreateManualScrapePostResponse> {
  const response = {
    external_id: "9d33aa5d-e222-46d3-8f6c-e280a1da2ccb",
    is_deleted: false,
    in_report: false,
    manually_added: true,
    content: {
      created_at: "2023-04-01",
      profile_url:
        "https://m.facebook.com/profile.php?id=100088979926928&paipv=0&eav=AfbvsrWEdWp_QINi8ynhrxZko3H7i7XSZEPp0VAVlqY595SlPeRZCo5QXK5hGPHF9JE&wtsid=rdr_0JbesFU3wqWGY8nf5",
      url: "https://m.facebook.com/story.php?story_fbid=pfbid0FYmzpSTbtzk5B3R311x6C3Wiu2JSWn4r7UZLv2RbL4WoVMXgreMaJouymrx2s11wl&id=100088979926928&eav=AfYXLWmM6pt4_CCrascQLurqQOlS77GYQtUdGKWbpo_qfXYQWXZWoiUbYpec3eWqku0&m_entstream_source=timeline&_ft_=encrypted_tracking_data.0AY9ZW1_w44Tolq3OqZpiZQa4aSw-HHT5BDP8t2AOxADG_REXI1l9-fDi-Ku3obMggcu06WEzwMHTtkLsRswxIp_2rBA5M7mzed6hPEpJCgreWQ69QscEhxy_a53rgOoyrpiRw42VRq6tlnD0bOWK-rfvqiXxhVMQXK9s7d0aTJ5rYda0gznY9q5FzQfRwM5JBKUM8yDuaJW8QjA82taXTmAP3rgKA1D6JySzRZB_cZ-Z96Nj_iXOOSpoFQ4CB40wot9IUTnPFf6JbPd0KGivr1-BKkCpUNhDxEIeETz7uUKNU4i76AGVPAPMrXzlZJdH_vpX1vBegFAfWSh12e4BcnDx9-btr-_K-DkZvb3bFEvNNoIgSI3G5O1uVyZ1ngnNbEnK5hCtaSRAcCe_kfHmP7e6kMO86BB74BiCvGzIWZz1Gbd9b-dKWgFNuLz4HUBw2LFzO_n6FFGgOueZY0xGDau-qzfEogDT8EiY8ymKAOv5O-0uv4qXEkzzrHVd41cTnC1nMbTsO-TjenX28afwTTmlmET8Qxso7-aJoGOxz6pdMXCcXhnkcB37mPRc3T3FGybhSX9QoGtz6xYHqvWl4vuKTNQpPdFvvuRMkLvsNX46hhBSdKhwBAjJCabNJZ0AL1bMAJECy-7N89bnM9QZns672j_yWTKNBf9GcAjwi-efWUHQHQOIKDufFL0bgrn59Q4aA7NHfiKG1x4Q-1t1pm4ecUVNdUkr_L3d6ZBPoWs9XD2xB6WVm5U-o4FJmmJMxhtOvuZFH_7iixWhpEgOMafQL9q5NvcdQAvoOeP03WyjjG9YmqTzMwARfLtB8Tfxak4ZQm2l9BcqKqmRuSxF6LmPYD5pBJEKHgPGBKDRF_lcghPqID44O8Lg9bspxNuZlB2r95hpdFk61N9nThpiwCofhELzziV0sTiBBqgKJ1NVXOFeACx6Q2Iwl-Y6W3oTEnEWP7-I6vRyRVD0AfmRLAhrbKs0ii0zDWz5XkmCjrNSUPvyveLb0x5uOy0Ysh900XLHtrAghyCpAYW5Jmkwei5WVKAqvBJZxnp-O66MtHGRshfoEoyPSOcL2KxK3igMSSO0jP-opL9TkXwZD3e_nAmFPuZZzhnsYc3bj8zb1_lzKtqHfyTiXwWpS2FIIEc3AS7_EPJMVAkel7DF01GDp_1baeg0g1VNIYXPlx1z9Aar4u11w-aHEgU9bbEG7Ud3nFmljvFyLffrLcDAFWlb8TNrRoSTI0nLpwAOH3SWuOKUJ4_YPBTWr-2fbtGOUjD8OFkjtvEWfcjoJdmjNgTDnQ2yiPn0viwQzwG4GfCNe906n7QXTu0SfBarfLS8GYj0yk7sAvjKkopWg3r9vSxt4Pk0dueMJj9neGXBgbMc-93kMrBFFQv86ZMFKCfnqn_DLpqQn4dtUUP8-qNJh5vpZW8e-lsOWZeIkrj97OcWxonAI5V1kO2dqIAAMFoI-g327nJY9jLtIw&__tn__=-R&paipv=0",
      type: "original",
      text: "Not sure why I didn’t think of this sooner to post lol but 3 ingredient PB Cookies! They won me first place at the fair every year! 1 egg 1 cup PB 1 cup Sugar Bake at 350 for 10 minutes! Enjoy ❤",
      media: [
        {
          external_url:
            "https://scontent-lax3-2.xx.fbcdn.net/v/t39.30808-6/338529410_147627831304877_8185012217142314708_n.jpg?stp=cp0_dst-jpg_e15_fr_q65&_nc_cat=103&ccb=1-7&_nc_sid=8024bb&efg=eyJpIjoidCJ9&_nc_ohc=dlTT4fz-nQ0AX9J08uw&tn=D07oWxAeGghMbZ8J&_nc_ht=scontent-lax3-2.xx&oh=00_AfBN8pHdaFdYtezQ1Z9ZA0dFxrfSWE7WEmCO_lcAGU04Aw&oe=6430C3DB",
          internal_url:
            "https://v3-fama-images-dev.s3.us-west-2.amazonaws.com/338529410_147627831304877_8185012217142314708_n.jpg?stp=cp0_dst-jpg_e15_fr_q65&_nc_cat=103&ccb=1-7&_nc_sid=8024bb&efg=eyJpIjoidCJ9&_nc_ohc=dlTT4fz-nQ0AX9J08uw&tn=D07oWxAeGghMbZ8J&_nc_ht=scontent-lax3-2.xx&oh=00_AfBN8pHdaFdYtezQ1Z9ZA0dFxrfSWE7WEmCO_lcAGU04Aw&oe=6430C3DB.jpeg",
          thumbnail_url:
            "https://scontent-lax3-2.xx.fbcdn.net/v/t39.30808-6/338529410_147627831304877_8185012217142314708_n.jpg?stp=cp0_dst-jpg_e15_fr_q65&_nc_cat=103&ccb=1-7&_nc_sid=8024bb&efg=eyJpIjoidCJ9&_nc_ohc=dlTT4fz-nQ0AX9J08uw&tn=D07oWxAeGghMbZ8J&_nc_ht=scontent-lax3-2.xx&oh=00_AfBN8pHdaFdYtezQ1Z9ZA0dFxrfSWE7WEmCO_lcAGU04Aw&oe=6430C3DB",
          type: "image",
          caption: "",
        },
      ],
      site_id: "",
    },
    is_reviewed: false,
    scrape_id: null,
  };
  return await buildMockPromise(response, 1000);
}

export async function updatePostsItemRatingMock(
  input: UpdateItemPostRatingRequest
): Promise<UpdateItemPostRatingResponse> {
  let response: UpdateItemPostRatingResponse = {
    item_uuid: input.item_uuid,
    ratings: input.ratings.map((rating) => ({
      external_id: uuidv4(),
      rater_uuid: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      name: rating.name,
      score_type: rating.score_type,
    })),
  };
  return await buildMockPromise(response, 1000);
}
